import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import Pricing from "@/components/Pricing";
import Testimonials from "@/components/Testimonials";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const Landing = () => {
  return (
    <main data-testid="landing-page" className="bg-[#FAFAFA] text-slate-900">
      <Header />
      <Hero />
      <Services />
      <WhyUs />
      <Pricing />
      <Testimonials />
      <FAQSection />
      <ContactSection />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
};

export default Landing;
